import { render, staticRenderFns } from "./UserRed20Rates.vue?vue&type=template&id=5bd1a94a&scoped=true&"
import script from "./UserRed20Rates.vue?vue&type=script&lang=ts&"
export * from "./UserRed20Rates.vue?vue&type=script&lang=ts&"
import style0 from "./UserRed20Rates.vue?vue&type=style&index=0&id=5bd1a94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd1a94a",
  null
  
)

export default component.exports